import { Component } from "@angular/core";
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
} from "ionic-angular";
import { DetalleOrdenPage } from "../detalle-orden/detalle-orden";
import { Order } from "../../models/order";
import { OrdenProvider } from "../../providers/orden/orden";
import { AuthProvider } from "../../providers/auth/auth";
import { LoginPage } from "../login/login";
import { OrdensPage } from "../ordens/ordens";
import * as moment from "moment";

@Component({
  selector: "page-crear-orden",
  templateUrl: "crear-orden.html",
})
export class CrearOrdenPage {
  name: any;
  today = new Date();
  FormatDate = moment(this.today).format("YYYY-MM-DDThh:mm:ss");
  arreglo = [];
  arregloMinutos = [];

  data: Order = {
    user: "",
    servicio: "",
    fecha: this.FormatDate,
    cliente: "",
    vendedor: "",
    frecuencia: "Unica Vez",
    estaciones: "0",
    trampas: "0",
    equipos: "0",
    unidades: "0",
    horario: "",
    minutos: 0,
    precio: 0,
    descuento: "",
    horas: 0,
    horasT: 0,
    minutosT: 0,
    tipo: "",
    telefono: "",
    dias_cita: "",
  };

  checked: boolean;
  _yScroll: any;
  _xScroll: any;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    private orderProvider: OrdenProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private alertCtrl: AlertController,
    public navParams: NavParams
  ) {
    this.checked = true;
  }

  ngOnInit() {
    this.name = this.navParams.get("name");
    this.data.vendedor = this.name;
    console.log(this.today);
    console.log(this.FormatDate);

    for (let index = 0; index <= 50; index++) {
      //any custom logic
      this.arreglo[index] = index;
    }

    for (let i = 0; i <= 59; i++) {
      //any custom logic
      this.arregloMinutos[i] = i;
    }
  }

  cotizar() {
    this.data.horasT = 0;
    this.data.minutosT = 0;
    this.data.precio = 0;
    if (this.data.frecuencia === "Unica vez") {
      this.data.estaciones = "0";
      this.data.trampas = "0";
      this.data.equipos = "0";
    }
    let tiempo_de_app =
      parseInt(this.data.estaciones) * 2 +
      parseInt(this.data.trampas) * 2 +
      parseInt(this.data.equipos) * 2;

    console.log(tiempo_de_app);
    let horas = parseInt(this.data.horas) * 60;
    console.log(horas);
    tiempo_de_app = tiempo_de_app + horas + parseInt(this.data.minutos);
    console.log(tiempo_de_app);

    if (tiempo_de_app > 0 && tiempo_de_app <= 30) {
      if (this.data.tipo == "Prestamo") {
        this.data.precio =
          parseInt(this.data.estaciones) * 18 +
          parseInt(this.data.trampas) * 26 +
          parseInt(this.data.equipos) * 210 +
          385;
      } else {
        this.data.precio = 385;
      }
      this.calminutos(tiempo_de_app);
    }

    if (tiempo_de_app > 30 && tiempo_de_app <= 45) {
      if (this.data.tipo == "Prestamo") {
        this.data.precio =
          parseInt(this.data.estaciones) * 18 +
          parseInt(this.data.trampas) * 26 +
          parseInt(this.data.equipos) * 210 +
          tiempo_de_app * 14;
      } else {
        this.data.precio = tiempo_de_app * 14.5;
      }
      this.calminutos(tiempo_de_app);
    }

    if (tiempo_de_app > 45 && tiempo_de_app <= 60) {
      if (this.data.tipo == "Prestamo") {
        this.data.precio =
          parseInt(this.data.estaciones) * 18 +
          parseInt(this.data.trampas) * 26 +
          parseInt(this.data.equipos) * 210 +
          tiempo_de_app * 14;
      } else {
        this.data.precio = tiempo_de_app * 14;
      }
      if (tiempo_de_app >= 60) {
        this.hora(tiempo_de_app);
        this.calminutos(tiempo_de_app);
      } else {
        this.calminutos(tiempo_de_app);
      }
    }

    if (tiempo_de_app > 60 && tiempo_de_app <= 120) {
      if (this.data.tipo == "Prestamo") {
        this.data.precio =
          parseInt(this.data.estaciones) * 18 +
          parseInt(this.data.trampas) * 26 +
          parseInt(this.data.equipos) * 210 +
          tiempo_de_app * 13;
      } else {
        this.data.precio = tiempo_de_app * 13;
        console.log(this.data.precio);
      }
      this.hora(tiempo_de_app);
      this.calminutos(tiempo_de_app);
    }

    if (tiempo_de_app > 120) {
      this.hora(tiempo_de_app);
      this.calminutos(tiempo_de_app);
    }

    this.EspFrecuencia(this.data.frecuencia);
    this.u_mosquicida(this.data.unidades, this.data.servicio);
    this.calhorario(this.data.horario);
    this.caldescuento(this.checked);
    this.data.precio = Math.trunc(this.data.precio);
    if (tiempo_de_app > 120) {
      this.data.precio = 0;
    }
  }

  hidden(value) {
    console.log(value);

    if (this.data.frecuencia === "Unica vez") {
      console.log("Ocultando....");
      // document.getElementById('labelTipo').style.display = 'none';
      document.getElementById("tipo").style.display = "none";
      document.getElementById("Unidades").style.display = "inline";
      document.getElementById("Servicio").style.display = "none";
      document.getElementById("estaciones").style.display = "none";
      document.getElementById("trampas").style.display = "none";
      document.getElementById("equipos").style.display = "none";
      document.getElementById("labelDescuento").style.display = "none";
      document.getElementById("app_desc").style.display = "none";

      this.data.tipo = "propias";
      this.data.unidades = "0";
      this.data.servicio = "Unico";
      this.checked = false;
    }

    if (this.data.frecuencia === "Bimensual") {
      console.log("Ocultando....");
      document.getElementById("labelTipo").style.display = "inline";
      document.getElementById("tipo").style.display = "inline";
      document.getElementById("Unidades").style.display = "none";
      document.getElementById("Servicio").style.display = "none";
      document.getElementById("estaciones").style.display = "inline";
      document.getElementById("trampas").style.display = "inline";
      document.getElementById("equipos").style.display = "inline";
      document.getElementById("labelDescuento").style.display = "inline-flex";
      document.getElementById("app_desc").style.display = "inline-flex";

      this.data.unidades = "0";
      this.data.servicio = "Sin";
    }

    if (this.data.frecuencia === "Quincenal") {
      console.log("Mostrando....");
      document.getElementById("labelTipo").style.display = "inline";
      document.getElementById("tipo").style.display = "inline";
      document.getElementById("Unidades").style.display = "inline";
      document.getElementById("Servicio").style.display = "inline";
      document.getElementById("estaciones").style.display = "inline";
      document.getElementById("trampas").style.display = "inline";
      document.getElementById("equipos").style.display = "inline";
      document.getElementById("labelDescuento").style.display = "inline-flex";
      document.getElementById("app_desc").style.display = "inline-flex";
      this.data.tipo = "";
      this.data.unidades = "";
      this.data.servicio = "";
    }

    if (this.data.frecuencia === "Mensual") {
      console.log("Mostrando....");
      document.getElementById("labelTipo").style.display = "inline";
      document.getElementById("tipo").style.display = "inline";
      document.getElementById("Unidades").style.display = "inline";
      document.getElementById("Servicio").style.display = "inline";
      document.getElementById("estaciones").style.display = "inline";
      document.getElementById("trampas").style.display = "inline";
      document.getElementById("equipos").style.display = "inline";
      document.getElementById("labelDescuento").style.display = "inline-flex";
      document.getElementById("app_desc").style.display = "inline-flex";
      this.data.tipo = "";
      this.data.unidades = "";
      this.data.servicio = "";
    }
  }

  calminutos(tiempo_de_app) {
    if (tiempo_de_app >= 120) {
      this.data.minutosT = 0;
      alert(
        "Tu tiempo de aplicación es mayor a dos horas. Por favor comunicate con la oficina"
      );
    }

    if (this.data.horasT >= 1 && tiempo_de_app <= 120) {
      console.log("hoo");
      this.data.minutosT = tiempo_de_app - 60 * this.data.horasT;

      if (this.data.minutosT == 0) {
        this.data.minutosT = this.data.minutosT + "0";
      }
    }
    if (tiempo_de_app < 60) {
      console.log("hooaaaa");
      this.data.minutosT = tiempo_de_app;
    }
  }

  hora(tiempo_de_app) {
    this.data.horasT = tiempo_de_app / 60;
    let horasT = Math.trunc(this.data.horasT);

    if (horasT == 1 || horasT == 2) {
      this.data.horasT = horasT;
    }

    if (horasT >= 2) {
      this.data.horasT = 0;
      // alert("no puedes cotizar aqui tu tiempo de aplicación es mayor a dos horas por lo que tienes que comunicarte a la oficina");
    }
    console.log("holaaaa soy horita");
  }

  u_mosquicida(unidades, servicio) {
    if (servicio == "Unico") {
      if (unidades == 1) {
        this.data.precio = this.data.precio + 412;
        console.log(this.data.precio);
      }

      if (unidades == 2) {
        this.data.precio = this.data.precio + 616;
        console.log(this.data.precio);
      }

      if (unidades == 3) {
        this.data.precio = this.data.precio + 825;
        console.log(this.data.precio);
      }
    }

    if (servicio == "Anual") {
      if (unidades == 1) {
        this.data.precio = this.data.precio + 440;
        console.log(this.data.precio);
      }

      if (unidades == 2) {
        this.data.precio = this.data.precio + 638;
        console.log(this.data.precio);
      }

      if (unidades == 3) {
        this.data.precio = this.data.precio + 770;
        console.log(this.data.precio);
      }
    }

    if (unidades >= 4) {
      this.data.minutosT = 0;
      this.data.horasT = 0;
      this.data.precio = 0;

      alert(
        "La cantidad de unidades es mayor a lo permitido. Por favor comunicate con la oficina"
      );
    }
  }

  calhorario(h_app) {
    console.log(h_app);
    if (h_app >= "20:00" && h_app <= "21:59") {
      this.data.precio = this.data.precio * 2;
      console.log(h_app);
      console.log(this.data.precio);
    }

    if (h_app >= "22:00" && h_app <= "23:59") {
      this.data.precio = this.data.precio * 4;
      console.log(h_app);
      console.log(this.data.precio);
    }

    if (h_app >= "00:00" && h_app <= "06:00") {
      this.data.precio = this.data.precio * 4;
      console.log(h_app);
      console.log(this.data.precio);
    }
  }

  caldescuento(des) {
    if (des == true) {
      let porcent = (this.data.precio * 20) / 100;
      this.data.precio = this.data.precio - porcent;
      this.data.descuento = "Si";
      console.log(this.data.precio);
    } else {
      this.data.descuento = "No";
      console.log(":(");
    }
  }

  EspFrecuencia(frecuencia) {
    if (frecuencia == "Unica vez") {
      let porcent = (this.data.precio * 30) / 100;
      this.data.precio = this.data.precio + porcent;
      console.log(this.data.precio);
    }

    if (frecuencia == "Quincenal") {
      let porcent = (this.data.precio * 30) / 100;
      this.data.precio = this.data.precio + porcent;
      console.log(this.data.precio);
    }

    if (frecuencia == "Bimensual") {
      let porcent = (this.data.precio * 30) / 100;
      this.data.precio = this.data.precio + porcent;
      console.log(this.data.precio);
    }
    console.log(this.data.precio);
  }

  goOrden() {
    this.alertCtrl
      .create({
        subTitle: "¿Estas seguro, quieres crear la cotización?",
        buttons: [
          "Cancelar",
          {
            text: "Si",
            handler: () => {
              let loading = this.loadingCtrl.create({
                content: "Creando orden...",
              });

              loading.present();
              console.log(this.data);
              this.orderProvider.saveOrder(this.data).subscribe(
                (res: Order) => {
                  loading.dismiss();
                  console.log(res);
                  if (res.id) {
                    this.navCtrl.setRoot(OrdensPage);
                  }
                },
                (err) => {
                  loading.dismiss();
                  console.log("ERROR: ", err);
                }
              );

              // this.navCtrl.push(DetalleOrdenPage, this.data);
            },
          },
        ],
      })
      .present();
  }

  logScrolling($event) {
    if ($event) {
      this._yScroll = $event.scrollTop;
      this._xScroll = $event.scrollLeft;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/crear-orden/crear-orden.ts